


export type InvoiceType = 'FlatRate' | 'RegieWithBillingType' | 'WarrantyWithBillingType' | 'KulanzAllotherm';

export const InvoiceType = {
    FlatRate: 'FlatRate' as InvoiceType,
    RegieWithBillingType: 'RegieWithBillingType' as InvoiceType,
    WarrantyWithBillingType: 'WarrantyWithBillingType' as InvoiceType,
    KulanzAllotherm: 'KulanzAllotherm' as InvoiceType
};

